export enum VelvetMachineDrawingInType {
  PILE,
  GROUND
}
